export interface IValidationMessages {
    [field: string]: string[];
}

export function isValidationMessages(input: any): input is IValidationMessages {
    const entries = Object.entries(input);
    return entries != null && entries.length > 0 && entries.at(0)!.length > 1;
}
